import { Navigate, Outlet } from "react-router-dom";
import "../layout/layout.css";

import AppSidebar from "../layout/AppSidebar";
import { useAuthContext } from "../context/AuthContext";

const ProtectedRoute = () => {
  const isLoggedIn = localStorage.getItem("loggedIn") === "true";
  const { currentUser, loading } = useAuthContext();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (loading || currentUser === null) {
    return (
      <div className="flex justify-content-center w-full font-bold">
        Loading...
      </div>
    );
  }

  return (
    <div className="flex">
      <AppSidebar />
      <div className="w-full ml-4">
        <Outlet />
      </div>
    </div>
  );
};

export default ProtectedRoute;
